/**
 * Angular imports.
 */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

/**
 * Component imports.
 */
import { CreateCommunityComponent } from './create-community/create-community.component';
import { CommunityComponent } from './community/community.component';
import { CommunityListingComponent } from './community-listing/community-listing.component';
import { CommunityDetailComponent } from './community-detail/community-detail.component';
import { CommunityListingPastComponent } from './community-listing-past/community-listing-past.component';

/**
 * Guard imports.
 */
import { CommunityListGuard } from './guards/community-list.guard';

const routes: Routes = [
  {
    path: '', component: CommunityComponent,
    children: [
      {
        path: 'list', component: CommunityListingComponent,
        resolve: { communityList: CommunityListGuard },
      },
      {
        path: 'past-list', component: CommunityListingPastComponent,
      },
      {
        path: 'createCommunity', component: CreateCommunityComponent
      },
      {
        path: 'editCommunity/:communityId', component: CreateCommunityComponent
      },
      {
        path: 'detail/:communityId', component: CommunityDetailComponent
      },
      {
        path: 'detail/:communityId/:tabName', component: CommunityDetailComponent
      },
      {
        path: 'detail/:communityId/:tabName/:referBy', component: CommunityDetailComponent
      },
      { path: '', redirectTo: 'list', pathMatch: 'full' },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WebCommunityRoutingModule { }
